import { isNil } from 'lodash';

import { getUserDisplayName } from 'utils/user';

/**
 * Maps the assigned-AE card endpoint into the relationship-card display shape.
 * Returns null when no AE is assigned (the endpoint returns { ae: null }) so the
 * card shows its "contact your AE" empty state instead of fabricated contact info.
 * @param {object|null} data - { ae: {...} | null, asOfUtc }
 * @returns {object|null}
 */
export const mapAccountExecutive = data => {
  if (isNil(data) || isNil(data.ae)) {
    return null;
  }

  const { ae } = data;

  return {
    userId: ae.userId ?? null,
    // Only the name fields are resolved: the card keeps `fullName` and `email` as separate fields,
    // so an unnamed AE must stay blank here rather than fall back to its email.
    fullName:
      getUserDisplayName({
        firstName: ae.firstName,
        lastName: ae.lastName,
        fullName: ae.fullName,
      }) ?? '',
    email: ae.email ?? null,
    phone: ae.phone ?? null,
  };
};
